import React from 'react';
import Icon from '../../../components/AppIcon';

const StatsOverview = ({ stats }) => {
  const renderStars = (rating) => {
    return Array.from({ length: 5 }, (_, index) => (
      <Icon
        key={index}
        name="Star"
        size={24}
        color={index < Math.floor(rating) ? 'var(--color-warning)' : 'var(--color-muted)'}
        className={index < Math.floor(rating) ? 'fill-current' : ''}
      />
    ));
  };

  return (
    <div className="bg-gradient-to-br from-primary/5 to-accent/5 rounded-2xl p-8 mb-12">
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
        <div className="lg:col-span-1 flex flex-col items-center justify-center text-center">
          <div className="flex gap-1 mb-3">{renderStars(stats?.averageRating)}</div>
          <div className="text-5xl font-bold text-foreground mb-2">{stats?.averageRating}</div>
          <p className="text-muted-foreground text-sm mb-1">out of 5 stars</p>
          <p className="text-foreground font-medium">{stats?.totalReviews} reviews</p>
        </div>

        <div className="lg:col-span-2">
          <div className="space-y-3">
            {stats?.ratingDistribution?.map((item) => (
              <div key={item?.stars} className="flex items-center gap-3">
                <div className="flex items-center gap-1 w-20">
                  <span className="text-sm font-medium text-foreground">{item?.stars}</span>
                  <Icon name="Star" size={14} color="var(--color-warning)" className="fill-current" />
                </div>
                <div className="flex-1 h-3 bg-muted rounded-full overflow-hidden">
                  <div
                    className="h-full bg-warning transition-all duration-500"
                    style={{ width: `${item?.percentage}%` }}
                  />
                </div>
                <span className="text-sm text-muted-foreground w-16 text-right">
                  {item?.count} ({item?.percentage}%)
                </span>
              </div>
            ))}
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mt-6 pt-6 border-t border-border">
            <div className="text-center">
              <div className="flex items-center justify-center gap-1 mb-1">
                <Icon name="Utensils" size={18} color="var(--color-primary)" />
                <span className="text-2xl font-bold text-foreground">{stats?.foodQuality}</span>
              </div>
              <p className="text-xs text-muted-foreground">Food Quality</p>
            </div>
            <div className="text-center">
              <div className="flex items-center justify-center gap-1 mb-1">
                <Icon name="Users" size={18} color="var(--color-primary)" />
                <span className="text-2xl font-bold text-foreground">{stats?.service}</span>
              </div>
              <p className="text-xs text-muted-foreground">Service</p>
            </div>
            <div className="text-center">
              <div className="flex items-center justify-center gap-1 mb-1">
                <Icon name="Home" size={18} color="var(--color-primary)" />
                <span className="text-2xl font-bold text-foreground">{stats?.atmosphere}</span>
              </div>
              <p className="text-xs text-muted-foreground">Atmosphere</p>
            </div>
            <div className="text-center">
              <div className="flex items-center justify-center gap-1 mb-1">
                <Icon name="DollarSign" size={18} color="var(--color-primary)" />
                <span className="text-2xl font-bold text-foreground">{stats?.value}</span>
              </div>
              <p className="text-xs text-muted-foreground">Value</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StatsOverview;